import { Pipe, PipeTransform } from '@angular/core';

import { COUNTRIES } from '../constants';
import { ECountry } from '../models';
import { ICompany } from 'app/core/interfaces';

@Pipe({ name: 'pCurrencyPlaceholder' })
export class PCurrencyPlaceholderPipe implements PipeTransform {
  transform(company?: any): string {
    if (!company) return COUNTRIES[ECountry.COLOMBIA].placeholder;

    return company?.currencySymbol;
  }
}
